import { render, staticRenderFns } from "./CreateBoard.vue?vue&type=template&id=1e47040e&scoped=true"
import script from "./CreateBoard.vue?vue&type=script&lang=js"
export * from "./CreateBoard.vue?vue&type=script&lang=js"
import style0 from "./CreateBoard.vue?vue&type=style&index=0&id=1e47040e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e47040e",
  null
  
)

export default component.exports